export default angular.module('ApiUtils.settings.djangoSite', []);
